/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrackingLine } from './TrackingLine';
import {
    TrackingLineFromJSON,
    TrackingLineFromJSONTyped,
    TrackingLineToJSON,
    TrackingLineToJSONTyped,
} from './TrackingLine';

/**
 * 
 * @export
 * @interface TrackingInfo
 */
export interface TrackingInfo {
    /**
     * 
     * @type {Array<TrackingLine>}
     * @memberof TrackingInfo
     */
    trackingLines: Array<TrackingLine>;
}

/**
 * Check if a given object implements the TrackingInfo interface.
 */
export function instanceOfTrackingInfo(value: object): value is TrackingInfo {
    if (!('trackingLines' in value) || value['trackingLines'] === undefined) return false;
    return true;
}

export function TrackingInfoFromJSON(json: any): TrackingInfo {
    return TrackingInfoFromJSONTyped(json, false);
}

export function TrackingInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'trackingLines': ((json['trackingLines'] as Array<any>).map(TrackingLineFromJSON)),
    };
}

  export function TrackingInfoToJSON(json: any): TrackingInfo {
      return TrackingInfoToJSONTyped(json, false);
  }

  export function TrackingInfoToJSONTyped(value?: TrackingInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trackingLines': ((value['trackingLines'] as Array<any>).map(TrackingLineToJSON)),
    };
}

